import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AiAssistantService } from 'src/app/domains/internal-facilities/ai-assistant/services/ai-assistant.service';
import { DictionaryItem } from 'voxloud-types/dist/models/ai-assistant/index';

@Component({
  selector: 'gdp-create-dictionary-popup',
  templateUrl: './create-dictionary-popup.component.html',
  styleUrls: ['./create-dictionary-popup.component.scss']
})
export class CreateDictionaryPopupComponent implements OnInit {
  public dictionaryItem: DictionaryItem;
  public isButtonDisabled: boolean = true;
  public loading: boolean = false;
  @Output() emitCreatedDictionary: EventEmitter<DictionaryItem> = new EventEmitter();

  constructor(
    private activeModal: NgbActiveModal,
    private aiAssistantService: AiAssistantService
  ) {}

  ngOnInit(): void { }

  public saveDictionaryItem(event: {dictionary: DictionaryItem, valid: boolean}): void {
    this.dictionaryItem = event.dictionary;
    this.isButtonDisabled = !event.valid;
  }

  public onSubmit(): void {
    this.loading = true;
    this.aiAssistantService.addDictionary(this.dictionaryItem).subscribe((res: DictionaryItem) => {
      this.emitCreatedDictionary.emit(res);
      this.loading = false;
      this.close();
    }, () => {
      this.loading = false;
      this.close();
    });
  }

  public close(): void {
    this.activeModal.close();
  }
}